/* eslint-disable @vfuk/rules/js-no-complex-ternary */
import type { FlattenSimpleInterpolation } from 'styled-components'
import { css } from 'styled-components'

import { respondTo } from '@vfuk/core-mixins'

import type { Size } from '../../SimpleSkeletonLoader.types'

export default function getLoaderSize(property: 'width' | 'height', value?: string | Size): FlattenSimpleInterpolation {
  return css`
    ${value &&
    css`
      ${property}: ${typeof value === 'object' ? value.sm : value};

      ${respondTo.md(css`
        ${property}: ${typeof value === 'object' ? value.md : value};
      `)}

      ${respondTo.lg(css`
        ${property}: ${typeof value === 'object' ? value.lg : value};
      `)}
  
      ${respondTo.xl(css`
        ${property}: ${typeof value === 'object' ? value.xl : value};
      `)}
    `}
  `
}
